import type { OptimizationBlockState } from './types'

/** Prefer API duration_ms; fall back to started_at → finished_at wall clock. */
export function resolveBlockDurationMs(block: OptimizationBlockState): number | undefined {
  if (block.duration_ms != null && block.duration_ms > 0) {
    return block.duration_ms
  }
  const start = block.started_at ? Date.parse(block.started_at) : Number.NaN
  const endRaw = block.finished_at ?? (block as { completed_at?: string }).completed_at
  const finish = endRaw ? Date.parse(endRaw) : Number.NaN
  if (Number.isFinite(start) && Number.isFinite(finish) && finish >= start) {
    return Math.max(1, finish - start)
  }
  return block.duration_ms
}
